import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { PwaInstallComponent } from './common/components';

@Component({
    selector: 'vex-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [RouterOutlet, PwaInstallComponent],
})
export class AppComponent {
    constructor(iconRegistry: MatIconRegistry) {
        iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
        console.log('%cStop!', 'color: red; font-size: 50px; font-weight: bold;');
        console.log(
            '%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a feature or "hack" an account, it is a scam and will give them access to your account.',
            'font-size: 16px; color: white;',
        );
    }
}
